import { render, staticRenderFns } from "./ColorSatisfaction.vue?vue&type=template&id=c08a3722&scoped=true&lang=pug&"
import script from "./ColorSatisfaction.vue?vue&type=script&lang=js&"
export * from "./ColorSatisfaction.vue?vue&type=script&lang=js&"
import style0 from "./ColorSatisfaction.vue?vue&type=style&index=0&id=c08a3722&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08a3722",
  null
  
)

export default component.exports